import Image from 'next/image.js';
import Link from 'next/link';
import parse from 'html-react-parser';
import { sprinkles } from '@/style/landingPage/theme.css';

export default function LatestNewsCard({ link, newWindow, heading, summary, image, }: {link: string, newWindow: boolean, heading: string, summary: string, image: string}) {


return (
      <Link href={link}
        target={newWindow ? '_blank' : '_self'}
        className={sprinkles({ display: 'flex', flexDirection: 'column', backgroundColor: 'gray100', height: 'full'}) }
        style={{ textDecoration: 'none' }}
      >
        { image &&
        <Image
          alt={heading ?? ''}
          src={image}
          style={{ width: '100%',  objectFit: 'cover',  }}
          height={260}
          width={450}

          className={sprinkles({
            height: {
              mobile: '180',
              tablet: '264'
            },
          })}
        />
        }
        <div className={sprinkles({
        paddingLeft: {
          mobile: 'lg',
          tablet: 'xxl',
        },
        paddingRight: {
          mobile: 'lg',
          tablet: 'xl',
        },
        paddingTop: {
          mobile: 'lg',
          tablet: 'xl', 
        },
        paddingBottom: {
          mobile: 'md',
          tablet: 'xxl',
        },
        position: 'relative', })}>
          <h4 className={sprinkles({
            fontSize: {
              mobile: 'twenty',
              tablet: 'lg'
            },
            lineHeight: {
              mobile: '28',
              tablet: 'xl'
            },
            color: 'navy',
            fontWeight: 500,
            marginBottom: {
              mobile: 'sm',
              tablet: 'lg',
            }
          })}
          >{heading}</h4>
          <div className={sprinkles({ color: 'navy', lineHeight: 'lg', fontSize: 'md'})}
          >{parse(summary || '')}</div>
        </div>
      </Link>
)

}